import {initializeApp} from "firebase/app"
import {getMessaging} from "firebase/messaging"
// import getConfigByName from "../config/index"
// import {BRAND_NAME} from "./_variable"
import {checkBrowserFirebaseCompatibility} from "../shared/_common/function"

// const firebaseConfig = getConfigByName(BRAND_NAME)?.fireBaseConfig

let messaging = null

async function initializeFirebase(firebaseConfig) {
    try {
        if (Object.keys(firebaseConfig).length > 0 && checkBrowserFirebaseCompatibility()) {
            const app = initializeApp(firebaseConfig)
            messaging = getMessaging(app)
        } else {
            console.log("Firebase config is missing, empty, or browser doesn't support Firebase Messaging.")
        }
    } catch (error) {}
}

export {initializeFirebase, messaging}
